import storageHelper from './storageHelper';
import rules from './pageRules';
import { getInfo, AUTH_USER } from '../modules/Auth/AuthActions';

function isOutside(search) {
  if (search.indexOf('app=trello') > -1 || search.indexOf('app=jira') > -1 || search.indexOf('app=akb') > -1) {
    return true;
  }
}

export function getTokenFromHash(tokenName) {
  let token = window.location.hash.substring(1) || storageHelper.storage().getItem(tokenName) || '';

  if (token.indexOf('%7B%22') === 0) {
    token = storageHelper.storage().getItem(tokenName) || '';
  }

  const hashIndex = token.indexOf('#');
  if (hashIndex > -1) {
    token = token.substring(0, hashIndex);
  }

  return token;
}

export function setup(tokenName) {
  const token = getTokenFromHash(tokenName);

  if (token) {
    storageHelper.storage().setItem(tokenName, token);
    history.pushState('', document.title, window.location.pathname + window.location.search);

    return true;
  }
}

export function getDisplayAuth(id) {
  return setup(id ? `displayToken_${id}` : 'displayToken');
}

export function dispatchGetInfo(store) {
  store.dispatch({ type: AUTH_USER, payload: { _id: 'temp', config: {} } });
  if (!rules.noHeader(window.location.pathname)) {
    store.dispatch(getInfo());
  }
}

export function checkToken(store) {
  if (rules.isWallboard(window.location.pathname)) {
    const id = window.location.pathname.split('/').slice(-2)[0];
    if (getDisplayAuth(id)) {
      dispatchGetInfo(store);
    }
  } else if (window.location.hash && !isOutside(window.location.search)) {
    const token = window.location.hash.substring(1);
    storageHelper.storage().setItem('token', token);
    history.pushState('', document.title, window.location.pathname + window.location.search);
    dispatchGetInfo(store);
  } else {
    dispatchGetInfo(store);
  }
}

export default {
  getTokenFromHash,
  setup,
  getDisplayAuth,
  dispatchGetInfo,
  checkToken
};
